module.exports = {
	"classes": [
		"partners-page",
		"header-dark"
	],
	"title": "Partners",
	"metas": {
		"description": "Grow your business in an increasingly developer-centric world of apps"
	},
	"opengraph": {
		"og:title": "",
		"og:description": "",
		"og:url": "https://auth0.com/partners",
		"og:image": "",
		"og:image:secure_url": ""
	},
	"twittercard": {
		"twitter:title": "",
		"twitter:description": "",
		"twitter:image": [
			{
				"src": ""
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/partners/metadata.json
// module id = 1425
// module chunks = 0